import { Link } from 'react-router-dom';
import styles from './Cta.module.css';
import shared from '../HomePage.module.css';

/**
 * ═══ CTA / FRANCHISE ═══
 * "가맹 창업 상담받기"는 원본과 동일하게 process.html#inquiry(가맹문의 신청서 섹션)로
 * 이동한다. react-router-dom SPA 라우팅은 해시가 있어도 자동 스크롤을 해주지 않으므로
 * src/components/ScrollToTop.jsx가 라우트 변경 시 해당 id로 스크롤 처리한다.
 */
export default function Cta() {
  return (
    <section className={`${shared.section} ${styles.cta}`} id="cta">
      <div className={`wrap ${styles.ctaInner}`}>
        <h2>아이의 첫 영어, 잉글리시팝과 함께 시작하세요</h2>
        <div className={styles.ctaRow}>
          <Link to="/process" className={`${shared.btn} ${shared.btnGhost} ${styles.ctaBtnGhost}`}>
            가맹 프로세스
          </Link>
          <Link to="/process#inquiry" className={`${shared.btn} ${shared.btnPrimary} ${styles.ctaBtnPrimary}`}>
            가맹 창업 상담받기
          </Link>
          <Link to="/apply" className={`${shared.btn} ${shared.btnPrimary} ${styles.ctaBtnPrimary}`}>
            본부 지원하기
          </Link>
        </div>
      </div>
    </section>
  );
}
